
export const SampleBadgeOffPremises = () => {
    return (
        <span className="badge li-bg-muted ml-2 li-fg-white">OFF-PREMISES</span>
    );
};